module.exports = __webpack_public_path__ + "static/img/8.77d32fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/8.png
// module id = Fh+2
// module chunks = 0